import { useMemo } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { AccountMenu } from "@/components/AccountMenu";
import { useAuth, STAFF_PATHS } from "@/lib/auth";
import { LayoutDashboard, Boxes, Scissors, FileText, Truck, Tag, Users, AlertTriangle, Layers, Package, ClipboardList, DatabaseBackup, Store, UserCog } from "lucide-react";

const navItems = [
  { to: "/", label: "Kontrol", icon: LayoutDashboard, testId: "nav-dashboard", end: true },
  { to: "/siparis", label: "Siparişler", icon: FileText, testId: "nav-orders" },
  { to: "/sevkiyat", label: "Sevkiyat", icon: Truck, testId: "nav-shipment" },
  { to: "/kesim", label: "Kesim", icon: Scissors, testId: "nav-cutting" },
  { to: "/taban-siparisleri", label: "Taban Siparişleri", icon: ClipboardList, testId: "nav-sole-orders" },
  { to: "/fuar", label: "Fuar Siparişleri", icon: Store, testId: "nav-fair" },
  { to: "/stok", label: "Stok", icon: Boxes, testId: "nav-stock" },
  { to: "/eksik", label: "Eksik Üretim", icon: AlertTriangle, testId: "nav-shortage" },
  { to: "/kart", label: "Stok Kartları", icon: Tag, testId: "nav-products" },
  { to: "/musteri", label: "Müşteriler", icon: Users, testId: "nav-customers" },
  { to: "/taban", label: "Tabanlar", icon: Layers, testId: "nav-soles" },
  { to: "/koli", label: "Koli Tipleri", icon: Package, testId: "nav-koli" },
  { to: "/yedek", label: "Yedekleme", icon: DatabaseBackup, testId: "nav-backup" },
  { to: "/personel", label: "Personel", icon: UserCog, testId: "nav-staff" },
];

export default function Layout() {
  const { user } = useAuth();
  const visibleNav = useMemo(() => navItems.filter((i) => user?.role === "admin" || STAFF_PATHS[user?.role]?.home === i.to), [user?.role]);
  return (
    <div className="min-h-screen flex flex-row bg-[#F5EFE4] text-[#2B2118]" data-testid="app-shell">
      <aside className="flex w-16 md:w-64 shrink-0 flex-col border-r border-[#DCCFB8] bg-[#FFFBF4] sticky top-0 h-screen overflow-y-auto" data-testid="sidebar">
        <div className="px-2 md:px-6 py-7 border-b border-[#DCCFB8]">
          <Logo className="hidden md:block text-[26px]" subtitle="Üretim Paneli" />
          <span className="md:hidden block text-center font-bold text-xl" style={{ fontFamily: "Helvetica, Arial, sans-serif" }}>C</span>
        </div>
        <nav className="flex-1 px-2 md:px-3 py-5 space-y-1" data-testid="sidebar-nav">
          {visibleNav.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} data-testid={item.testId} title={item.label}
              className={({ isActive }) =>
                `flex items-center justify-center md:justify-start gap-3 px-2 md:px-4 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#D97706] text-white shadow-md shadow-amber-900/40"
                    : "text-[#6B5B4A] hover:bg-[#EFE6D6] hover:text-[#2B2118]"
                }`
              }>
              <item.icon className="w-4 h-4 shrink-0" />
              <span className="hidden md:inline font-display tracking-wide uppercase">{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <AccountMenu />
        <div className="hidden md:block px-6 py-4 border-t border-[#DCCFB8] text-[10px] font-mono uppercase tracking-widest text-[#8C7B68]">
          v1.1 · Atölye Edition
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
